// extracted by mini-css-extract-plugin
export default {"columns":"risk_columns__wuAGd","description":"risk_description__Y3ogF","status":"risk_status__kZWfs","statsInfo":"risk_statsInfo__z0YVO"};